
import { css } from 'lit';
export default css`
pc-testimonial [slot='footer'] pc-caption{
  --pc-caption-color:var(--testimonial-text-color);
}

pc-testimonial pc-heading > *{
  display:-webkit-box;
  -webkit-line-clamp:5;
  -webkit-box-orient:vertical;
  overflow:hidden;
}
`;